/* Bulk Operation Toast Styles */

.bulk-operation-toast {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 400px;
  max-width: calc(100vw - 40px);
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 16px;
  z-index: 9999;
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    transform: translateX(calc(100% + 20px));
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.bulk-operation-toast-header {
  margin-bottom: 12px;
}

.bulk-operation-toast-body {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Stacking support for multiple toasts */
.bulk-operation-toast:nth-child(2) {
  bottom: calc(20px + 120px);
}

.bulk-operation-toast:nth-child(3) {
  bottom: calc(20px + 240px);
}

.bulk-operation-toast:nth-child(4) {
  bottom: calc(20px + 360px);
}

/* Responsive for mobile */
@media (max-width: 768px) {
  .bulk-operation-toast {
    width: calc(100vw - 32px);
    left: 16px;
    right: 16px;
    bottom: 16px;
  }

  .bulk-operation-toast:nth-child(2) {
    bottom: calc(16px + 100px);
  }

  .bulk-operation-toast:nth-child(3) {
    bottom: calc(16px + 200px);
  }

  .bulk-operation-toast:nth-child(4) {
    bottom: calc(16px + 300px);
  }
}
